/*-----------------------------------------------------------------------------/
/ Geschenkverpackung ist kein eigenes Produkt: direkte Produktseite umleiten
/-----------------------------------------------------------------------------*/
(() => {
  if (/\/products\/geschenkpapier\/?$/.test(window.location.pathname)) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.replace(root);
  }
})();

/*-----------------------------------------------------------------------------/
/ Beluga Kids – Custom Theme JS
/ Geschenkverpackung pro Artikel (Produktseite + Warenkorb)
/-----------------------------------------------------------------------------*/

(() => {
  const dataEl = document.getElementById('beluga-gift-data');
  if (!dataEl) return;

  let GIFT;
  try {
    GIFT = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!GIFT || !GIFT.variantId) return;

  const GIFT_VARIANT = Number(GIFT.variantId);
  const KEY_TIME = '_gift_time';
  const KEY_CARD = '_gift card';
  const KEY_LINK = '_added_product_id';

  const locale = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  const TEXT = {
    de: { add: 'Als Geschenk verpacken', for: 'Geschenkverpackung für', unlinked: 'Bitte entferne diese Zeile und setze beim gewünschten Artikel das Häkchen «Als Geschenk verpacken».' },
    fr: { add: 'Emballer comme cadeau', for: 'Emballage cadeau pour', unlinked: 'Veuillez supprimer cette ligne et cocher « Emballer comme cadeau » sous l’article souhaité.' },
    en: { add: 'Gift wrap this item', for: 'Gift wrap for', unlinked: 'Please remove this line and tick «Gift wrap this item» on the item you want wrapped.' },
    it: { add: 'Confezione regalo', for: 'Confezione regalo per', unlinked: 'Rimuovi questa riga e seleziona «Confezione regalo» sull’articolo desiderato.' }
  }[locale] || { add: 'Als Geschenk verpacken', for: 'Geschenkverpackung für', unlinked: 'Bitte entferne diese Zeile und setze beim gewünschten Artikel das Häkchen «Als Geschenk verpacken».' };

  const ICON = '<svg class="beluga-gift__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3.5" y="9" width="17" height="11.5" rx="1" fill="#C0D5DB"/><rect x="2.5" y="6.5" width="19" height="3.5" rx="1" fill="none" stroke="#1E1E1C" stroke-width="1.3"/><path d="M12 6.5v14M3.5 10v10.5h17V10" fill="none" stroke="#1E1E1C" stroke-width="1.3"/><path d="M12 6.5c-1.6-2.9-4.8-3.4-5.3-1.6-.5 1.9 3.1 1.6 5.3 1.6Zm0 0c1.6-2.9 4.8-3.4 5.3-1.6.5 1.9-3.1 1.6-5.3 1.6Z" fill="none" stroke="#1E1E1C" stroke-width="1.3" stroke-linejoin="round"/></svg>';

  let cartModulePromise = null;
  const getCart = () => {
    if (!cartModulePromise) cartModulePromise = import('cart-store').then((m) => m.default);
    return cartModulePromise;
  };

  const buildBox = (id) => {
    const wrap = document.createElement('div');
    wrap.className = 'beluga-gift';
    wrap.innerHTML =
      '<label class="beluga-gift__label" for="' + id + '">' +
        '<input class="beluga-gift__input" type="checkbox" id="' + id + '">' +
        ICON + '<span>' + TEXT.add + '</span>' +
      '</label>' +
      '<span class="beluga-gift__price">+ ' + GIFT.price + '</span>';
    return wrap;
  };

  const stripGiftProps = (props) => {
    const clean = {};
    Object.keys(props || {}).forEach((k) => {
      if (k !== KEY_TIME && k !== KEY_CARD) clean[k] = props[k];
    });
    return clean;
  };

  const postJSON = (url, body) =>
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then((r) => r.json());

  const addWrapLine = (time) =>
    postJSON('cart/add.js', {
      items: [{ id: GIFT_VARIANT, quantity: 1, properties: { [KEY_TIME]: String(time), [KEY_LINK]: String(time) } }]
    });

  /* ---------------- Produktseite ---------------- */

  let pendingPdpGift = null;

  const initProductPage = () => {
    if (!GIFT.productGiftOption) return;
    document.querySelectorAll('.product-single form.js-product-form, product-single form.js-product-form').forEach((form, i) => {
      if (form.dataset.belugaGift) return;
      // nur Hauptprodukt – nicht in «Passt dazu», Quick-Shop-Karten o. ä.
      if (form.closest('.crosscell_pdp, .croscell_product_ul, product-card, .product-card, quick-shop')) return;
      const anchor = form.querySelector('.product-form__add');
      if (!anchor) return;
      form.dataset.belugaGift = '1';
      const box = buildBox('beluga-gift-pdp-' + i);
      anchor.parentNode.insertBefore(box, anchor);
    });
  };

  // Läuft in der Capture-Phase, also bevor das Theme das Formular verarbeitet.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.dataset.belugaGift) return;

    form.querySelectorAll('input[data-beluga-gift-prop]').forEach((el) => el.remove());
    const box = form.querySelector('.beluga-gift__input');
    if (!box || !box.checked) return;

    const time = Date.now();
    [[KEY_TIME, time], [KEY_CARD, GIFT_VARIANT]].forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      input.value = String(value);
      input.dataset.belugaGiftProp = '1';
      form.appendChild(input);
    });
    pendingPdpGift = time;
  }, true);

  document.addEventListener('on:cart:loaded', async (event) => {
    if (!event.detail || event.detail.type !== 'ADD' || !pendingPdpGift) return;
    const time = pendingPdpGift;
    pendingPdpGift = null;
    try {
      await addWrapLine(time);
      const Cart = await getCart();
      await Cart.refresh();
    } catch (e) {
      console.warn('Beluga Geschenkverpackung:', e);
    }
  });

  document.addEventListener('on:cart:failed', (event) => {
    if (event.detail && event.detail.type === 'ADD') pendingPdpGift = null;
  });

  /* ---------------- Warenkorb ---------------- */

  const tagCache = new Map();
  const hasGiftOption = (handle) => {
    if (!handle) return Promise.resolve(false);
    if (!tagCache.has(handle)) {
      tagCache.set(handle,
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'products/' + handle + '.js')
          .then((r) => (r.ok ? r.json() : { tags: [] }))
          .then((p) => (p.tags || []).includes('_gift_option'))
          .catch(() => false));
    }
    return tagCache.get(handle);
  };

  let busy = false;

  const findWrapLine = (items, time) =>
    items.find((it) => it.variant_id === GIFT_VARIANT && it.properties && String(it.properties[KEY_TIME]) === String(time));

  const toggleCartGift = async (item, checked, box) => {
    if (busy) return;
    busy = true;
    box.setAttribute('aria-busy', 'true');
    try {
      const Cart = await getCart();
      if (checked) {
        const time = Date.now();
        await Cart.change({
          id: item.key,
          quantity: item.quantity,
          properties: { ...stripGiftProps(item.properties), [KEY_TIME]: String(time), [KEY_CARD]: String(GIFT_VARIANT) }
        });
        await addWrapLine(time);
      } else {
        const state = Cart.getState();
        const items = (state.cart && state.cart.items) || [];
        const wrap = findWrapLine(items, item.properties[KEY_TIME]);
        if (wrap) await postJSON('cart/change.js', { id: wrap.key, quantity: 0 });
        await Cart.change({ id: item.key, quantity: item.quantity, properties: { ...stripGiftProps(item.properties), [KEY_TIME]: '', [KEY_CARD]: '' } });
      }
      await Cart.refresh();
    } catch (e) {
      console.warn('Beluga Geschenkverpackung:', e);
    } finally {
      busy = false;
      box.removeAttribute('aria-busy');
    }
  };

  // Verwaiste Verpackungen entfernen (z.B. wenn der Artikel gelöscht wurde)
  let cleaning = false;
  const cleanOrphans = async (items) => {
    if (cleaning || busy) return;
    const orphans = items.filter((it) => {
      if (it.variant_id !== GIFT_VARIANT || !it.properties || !it.properties[KEY_TIME]) return false;
      return !items.some((p) => p.variant_id !== GIFT_VARIANT && p.properties && String(p.properties[KEY_TIME]) === String(it.properties[KEY_TIME]));
    });
    if (!orphans.length) return;
    cleaning = true;
    try {
      const updates = {};
      orphans.forEach((o) => { updates[o.key] = 0; });
      await postJSON('cart/update.js', { updates });
      const Cart = await getCart();
      await Cart.refresh();
    } catch (e) {
      console.warn('Beluga Geschenkverpackung:', e);
    } finally {
      cleaning = false;
    }
  };

  const decorateCart = async () => {
    const elements = document.querySelectorAll('cart-item[key]');
    if (!elements.length) return;
    const Cart = await getCart();
    const state = Cart.getState();
    const items = (state.cart && state.cart.items) || [];
    if (!items.length) {
      setTimeout(scheduleDecorate, 400);
      return;
    }

    for (const el of elements) {
      const key = el.getAttribute('key');
      const item = items.find((it) => it.key === key);
      if (!item) continue;

      // Verpackungszeile: Hinweis, für welchen Artikel
      if (item.variant_id === GIFT_VARIANT) {
        const time = item.properties && item.properties[KEY_TIME];
        const owner = time && items.find((p) => p.variant_id !== GIFT_VARIANT && p.properties && String(p.properties[KEY_TIME]) === String(time));
        const details = el.querySelector('.cart-item__details') || el;
        let note = el.querySelector('.beluga-gift-note');
        // Menge der Verpackungszeile nicht veränderbar (immer 1 pro Artikel)
        el.classList.add('beluga-gift-line');
        if (!note) {
          note = document.createElement('span');
          note.className = 'beluga-gift-note';
          (details.querySelector('.cart-item__header') || details).appendChild(note);
        }
        if (owner) {
          note.classList.remove('beluga-gift-note--warn');
          note.textContent = TEXT.for + ' ' + owner.product_title;
        } else {
          note.classList.add('beluga-gift-note--warn');
          note.textContent = TEXT.unlinked;
        }
        continue;
      }

      if (item.gift_card) continue;
      if (!(await hasGiftOption(item.handle))) continue;

      const isChecked = Boolean(item.properties && item.properties[KEY_TIME] && item.properties[KEY_CARD]);
      let box = el.querySelector('.beluga-gift');
      if (!box) {
        box = buildBox('beluga-gift-' + key.replace(/[^a-z0-9]/gi, ''));
        const details = el.querySelector('.cart-item__details') || el;
        details.appendChild(box);
      }
      const input = box.querySelector('input');
      input.checked = isChecked;
      input.onchange = () => toggleCartGift(item, input.checked, box);
    }

    cleanOrphans(items);
  };

  let scheduled = false;
  const scheduleDecorate = () => {
    if (scheduled) return;
    scheduled = true;
    setTimeout(() => {
      scheduled = false;
      decorateCart().catch((e) => console.warn('Beluga Geschenkverpackung:', e));
    }, 30);
  };

  const injectStyle = () => {
    if (document.getElementById('beluga-gift-line-style')) return;
    const st = document.createElement('style');
    st.id = 'beluga-gift-line-style';
    st.textContent = '.beluga-gift-line cart-item-quantity{display:none!important}' +
      '.beluga-gift-note--warn{display:block;color:#b3261e;font-size:.85em;margin-top:.35em}';
    document.head.appendChild(st);
  };

  const start = () => {
    injectStyle();
    initProductPage();
    scheduleDecorate();
    getCart().then((Cart) => {
      if (typeof Cart.subscribe === 'function') Cart.subscribe(scheduleDecorate);
      scheduleDecorate();
    }).catch(() => {});
    document.addEventListener('on:cart:loaded', scheduleDecorate);
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1 && (n.matches('cart-item, form.js-product-form') || n.querySelector('cart-item, form.js-product-form'))) {
            initProductPage();
            scheduleDecorate();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/*-----------------------------------------------------------------------------/
/ FAQ-Seite: Reiter für Kategorien (ersetzt die alte jQuery-Version)
/-----------------------------------------------------------------------------*/
(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.custom_faq_details');
    if (!link) return;
    event.preventDefault();
    const cat = link.getAttribute('data_cate');
    const root = link.closest('section, .shopify-section') || document;
    root.querySelectorAll('.custom_faq_item').forEach((li) => li.classList.remove('active'));
    const li = link.closest('li');
    if (li) li.classList.add('active');
    root.querySelectorAll('.custom_faq_data[data_cate]').forEach((el) => {
      el.hidden = el.getAttribute('data_cate') !== cat;
    });
    root.querySelectorAll('.custom_faq_artical[data_cate]').forEach((el) => {
      el.hidden = el.getAttribute('data_cate') !== cat;
    });
  });
})();

/*-----------------------------------------------------------------------------/
/ Shop the Look: Lade-Zustand entfernen (früher erledigte das Slick)
/-----------------------------------------------------------------------------*/
(() => {
  const ready = () => document
    .querySelectorAll('.hotspotImageSlider_cls .home-carousel--image--loading')
    .forEach((el) => el.classList.remove('home-carousel--image--loading'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();

/* ===== Beluga Kids: Klaviyo Favorites – Herz neben «In den Warenkorb» (Produktseite) ===== */
(function () {
  var slot = null;
  function place() {
    slot = slot || document.getElementById('bk-pdp-wish-slot');
    var wrap = document.querySelector('.product-form--single .js-product-buttons');
    if (!slot || !wrap) return;
    if (slot.parentNode !== wrap) {
      wrap.appendChild(slot); /* verschiebt den bestehenden Knoten inkl. Klaviyo-Inhalt */
      wrap.classList.add('bk-has-wish');
    }
    slot.hidden = false;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(place, 100); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* ===== Beluga Kids: «(CHF CHF)» → «(CHF)» in Länderauswahl; leere Klaviyo-Bewertungen ausblenden ===== */
(function () {
  function tidy() {
    document.querySelectorAll('.localization-form__country').forEach(function (el) {
      var t = el.textContent.replace(/\s+/g, ' ').trim();
      var m = t.match(/^\((\S+) (\S+)\)$/);
      if (m && m[1] === m[2]) el.textContent = '(' + m[1] + ')';
    });
    document.querySelectorAll('[id*="klaviyo_reviews"], #klaviyo-product-reviews-wrapper').forEach(function (el) {
      var txt = (el.innerText || '').trim();
      if (/Noch keine Bewertungen|No reviews yet|Aucun avis/i.test(txt)) {
        var sec = el.closest('.shopify-section') || el;
        sec.style.display = 'none';
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tidy); else tidy();
  var n = 0, iv = setInterval(function () { tidy(); if (++n > 20) clearInterval(iv); }, 750);
})();

/* ===== Beluga Kids: Suchlupe oben im mobilen Menü (wie altes Theme) ===== */
(function () {
  function add() {
    var box = document.querySelector('.mobile-draw__account');
    if (!box || box.querySelector('.beluga-drawer-search')) return;
    var src = document.querySelector('.search-draw-trigger-icon a, .header-trigger__link--search');
    var a = document.createElement('a');
    a.href = '/search';
    a.className = 'mobile-footer__text-link beluga-drawer-search';
    a.setAttribute('aria-label', 'Suche');
    a.setAttribute('aria-haspopup', 'dialog');
    a.setAttribute('data-a11y-dialog-show', 'modal-search');
    a.innerHTML = src ? src.innerHTML : 'Suche';
    box.insertBefore(a, box.firstChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', add); else add();
})();

/* ===== Beluga Kids: einheitliche Fortschrittslinie unter allen Karussells ===== */
(function () {
  var SEL = '.items-scroll [data-items], .template-index .section--collections-list .grid-layout';
  function setup() {
    document.querySelectorAll(SEL).forEach(function (sc) {
      if (sc.__bkp) return;
      var ov = getComputedStyle(sc).overflowX;
      if (ov !== 'auto' && ov !== 'scroll') return;
      if (sc.scrollWidth <= sc.clientWidth + 4) return;
      sc.__bkp = true;
      var bar = document.createElement('div');
      bar.className = 'bk-progress';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<span></span>';
      var host = sc.closest('.items-scroll') || sc;
      host.parentNode.insertBefore(bar, host.nextSibling);
      var s = bar.firstChild;
      function u() {
        var r = Math.min(1, sc.clientWidth / sc.scrollWidth);
        var max = sc.scrollWidth - sc.clientWidth;
        var p = max > 0 ? sc.scrollLeft / max : 0;
        bar.style.display = r >= 0.99 ? 'none' : '';
        s.style.width = (r * 100) + '%';
        s.style.transform = 'translateX(' + (p * (1 / r - 1) * 100) + '%)';
      }
      sc.addEventListener('scroll', u, { passive: true });
      window.addEventListener('resize', u);
      u();
    });
  }
  function run() { setup(); setTimeout(setup, 1200); setTimeout(setup, 3500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('resize', function () { setTimeout(setup, 300); });
})();

/* ===== Beluga Kids: Über-uns-Banner sofort anzeigen (Ladezustand des alten Karussells entfernen) ===== */
(function () {
  function go() { document.querySelectorAll('.about_image_banner_cls .home-carousel--image--loading').forEach(function (el) { el.classList.remove('home-carousel--image--loading'); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

/* ===== Beluga Kids: «Passt dazu» – gewählte Grösse wirklich in den Warenkorb legen ===== */
(function () {
  var cache = {};
  function productUrl(li) {
    var a = li.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0].split('#')[0] : null;
  }
  function getProduct(url) {
    if (!cache[url]) cache[url] = fetch(url + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    return cache[url];
  }
  function sync(li) {
    var url = productUrl(li); if (!url) return Promise.resolve();
    var selects = Array.prototype.slice.call(li.querySelectorAll('select'));
    if (!selects.length) return Promise.resolve();
    return getProduct(url).then(function (p) {
      var names = (p.options || []).map(function (o) { return (typeof o === 'string' ? o : o.name || '').trim(); });
      var wanted = [];
      selects.forEach(function (s, i) {
        var m = (s.name || '').match(/options\[(.*)\]/);
        var idx = m ? names.indexOf(m[1].trim()) : i;
        if (idx < 0) idx = i;
        wanted[idx] = s.value;
      });
      var v = p.variants.filter(function (v) {
        return wanted.every(function (val, i) { return val === undefined || v.options[i] === val; });
      })[0];
      if (!v) return;
      li.querySelectorAll('input[name="id"]').forEach(function (inp) { inp.value = v.id; });
      li.setAttribute('product-var-id', v.id);
      var btn = li.querySelector('.product-card-btn__btn');
      if (btn) btn.disabled = !v.available;
    });
  }
  document.addEventListener('change', function (e) {
    var li = e.target.closest && e.target.closest('.crosscell_pdp li.pdp_detail');
    if (li && e.target.tagName === 'SELECT') sync(li);
  }, true);
  document.addEventListener('focusin', function (e) {
    var li = e.target.closest && e.target.closest('.crosscell_pdp li.pdp_detail');
    if (li) { var u = productUrl(li); if (u) getProduct(u); }
  }, true);
  // Produktdaten vorladen, damit die Auswahl sofort übernommen wird
  function preload() {
    document.querySelectorAll('.crosscell_pdp li.pdp_detail').forEach(function (li) {
      var u = productUrl(li); if (!u || !li.querySelector('select')) return;
      getProduct(u).then(function (p) {
        var sels = li.querySelectorAll('select');
        if (sels.length === 1 && p.options && p.options.length === 1) {
          Array.prototype.forEach.call(sels[0].options, function (o) {
            var v = p.variants.filter(function (v) { return v.options[0] === o.value; })[0];
            if (v && !v.available && !/ausverkauft|épuisé|sold out/i.test(o.text)) {
              var lang = (document.documentElement.lang || 'de').slice(0, 2);
              o.text = o.text + (lang === 'fr' ? ' – épuisé' : lang === 'en' ? ' – sold out' : ' – ausverkauft');
            }
          });
        }
        sync(li);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preload); else preload();
})();

/* ===== Beluga Kids: Header-Herz → Klaviyo Favorites (bis header.liquid direkt angepasst ist) ===== */
(function () {
  function fix() {
    document.querySelectorAll('a[href="#swym-wishlist"], a.swym-wishlist').forEach(function (a) {
      a.setAttribute('href', '#k-hub/favorites');
      a.classList.remove('swym-wishlist');
      a.classList.add('bk-fav-link');
      a.setAttribute('aria-label', 'Favoriten');
      a.setAttribute('title', 'Favoriten');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
})();

/* ===== Beluga Kids: Währungsformat mit Apostroph (CHF 1'234.00) auch in JS-Preisen =====
   Das Theme-JS kennt {{amount_with_apostrophe_separator}} nicht und zeigt sonst nur «CHF». */
(function () {
  var KEYS = ['money_format', 'money_with_currency_format', 'money_product_price_format', 'money_total_price_format'];
  function patch() {
    var t = window.theme;
    if (!t) return;
    KEYS.forEach(function (k) {
      if (typeof t[k] === 'string' && t[k].indexOf('amount_with_apostrophe_separator') > -1) {
        t[k] = t[k].replace(/amount_with_apostrophe_separator/g, 'amount');
      }
    });
  }
  patch();
  document.addEventListener('DOMContentLoaded', patch);
  /* «1,234.00» → «1'234.00» in JS-gerenderten Preisen */
  var RE = /(\d),(?=\d{3}(?:[,.]|\b))/g;
  function fix(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = w.nextNode())) {
      if (/CHF|EUR|\.\d{2}/.test(n.nodeValue) && /\d,\d{3}/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(RE, "$1'");
    }
  }
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      m.addedNodes.forEach(function (x) {
        if (x.nodeType === 1 && x.closest && x.closest('.money, [class*=price], [class*=total], cart-item, cart-items, .cart')) fix(x);
        else if (x.nodeType === 3 && x.parentElement && x.parentElement.closest('.money, [class*=price], [class*=total]')) fix(x.parentElement);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/*-----------------------------------------------------------------------------/
/ Kollektionen: nach «Mehr anzeigen» + Produktseite beim Zurückgehen
/ an derselben Stelle weitermachen (geladene Produkte + Scrollposition)
/-----------------------------------------------------------------------------*/
(() => {
  const KEY = 'bk-plp-restore';
  const MAX_AGE = 30 * 60 * 1000; // 30 Minuten
  const here = () => window.location.pathname + window.location.search;

  const getRoot = () => document.querySelector('dynamic-product-search[data-infinite="true"]');

  // Beim Klick auf ein Produkt den aktuellen Stand merken
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="/products/"]');
    if (!link) return;
    const root = getRoot();
    if (!root || !root.contains(link)) return;
    const results = root.querySelector('.js-results');
    if (!results) return;
    const cards = results.querySelectorAll('product-card, .search-grid-item').length;
    // Klaviyo-Herzen leeren, damit Klaviyo sie beim Wiederherstellen neu und funktionsfähig zeichnet
    const clone = results.cloneNode(true);
    clone.querySelectorAll('.klaviyo-favorites-plp-slot').forEach((slot) => {
      slot.innerHTML = '';
      slot.removeAttribute('data-rendered');
    });
    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        path: here(),
        html: clone.innerHTML,
        cards,
        scrollY: window.scrollY,
        time: Date.now()
      }));
    } catch (e) { /* Speicher voll oder gesperrt – dann normal weiter */ }
  }, true);

  const restore = () => {
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { saved = null; }
    if (!saved || saved.path !== here() || Date.now() - saved.time > MAX_AGE) return;

    const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!nav || nav.type !== 'back_forward') return;

    const root = getRoot();
    const results = root && root.querySelector('.js-results');
    if (!results) return;

    const currentCards = results.querySelectorAll('product-card, .search-grid-item').length;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    if (saved.cards > currentCards) {
      results.innerHTML = saved.html;
      const ctrl = root.infiniteController;
      if (ctrl) {
        if (typeof ctrl.updateCount === 'function') ctrl.updateCount();
        if (typeof ctrl.setupLoadMoreButton === 'function') ctrl.setupLoadMoreButton();
      }
    }
    // zweimal setzen: sofort und nachdem Bilder/Layout nachgezogen haben
    window.scrollTo(0, saved.scrollY);
    setTimeout(() => window.scrollTo(0, saved.scrollY), 300);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(restore, 0));
  } else {
    setTimeout(restore, 0);
  }
})();
